// 公共路由部分
const commonRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/ProductList',
    name: 'MyProduct',
    component: () => import('@/views/product/ProductList.vue')
  },
  {
    path: '/ProductDetail',
    name: 'ProductDetail',
    component: () => import('@/views/product/ProductDetail.vue')
  },
  {
    path: '/ServiceList',
    name: 'MyService',
    component: () => import('@/views/service/ServiceList.vue')
  },
  {
    path: '/ServiceDetail',
    name: 'FormDetail',
    component: () => import('@/views/service/survey/FormDetail.vue')
  },
  {
    path: '/Introduction',
    name: 'introduction',
    component: () => import('@/views/home/Introduction.vue')
  },
  {
    path: '/agreement',
    name: 'AgreementDetail',
    component: () => import('@/views/service/survey/AgreementDetail.vue')
  },
  // 首页
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/Home.vue')
  },
  // 错误提示页
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/error/401.vue'),
    hidden: true
  },
  {
    path: '/report',
    name: 'report',
    // component: () => import('@/views/report/ReportDownload.vue'),
    component: () => {
      // 判断是否为手机端（可根据UserAgent或屏幕尺寸）
      const isMobile = /Mobile|Android|iOS/i.test(navigator.userAgent)
        || window.innerWidth <= 768 // 假设768px以下为手机/平板

      return isMobile
        ? import('@/views/report/ReportInApp.vue')
        : import('@/views/report/ReportDownload.vue')
    },
    hidden: true
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/error/404.vue'),
    hidden: true
  },
  {
    path: '/export',
    name: 'export',
    component: () => import('@/views/report/ReportDownload.vue')
  },
  {
    path: '/debug',
    name: 'debug',
    component: () => import('@/components/debug.vue')
  }
]

const siteRoutes = [
  // {
  //   path: '/test',
  //   name: 'test',
  //   component: () => import('@/website/TestUpload.vue')
  // },
  {
    path: '/site',
    name: 'site',
    redirect: '/site/first',
    component: () => import('@/website/SiteWeb.vue'),
    children: [
      {
        path: '/site/first',
        name: 'First',
        meta: {
          title: '首页'
        },
        component: () => import('@/website/home/First.vue')
      },
      {
        path: '/site/case',
        name: 'Case',
        meta: {
          title: '成功案例'
        },
        component: () => import('@/website/case/Case.vue')
      },
      {
        path: '/site/info',
        name: 'Info',
        meta: {
          title: '企业介绍'
        },
        component: () => import('@/website/info/Info.vue')
      },
      {
        path: '/site/ProList',
        name: 'ProList',
        meta: {
          title: '产品'
        },
        component: () => import('@/website/product/ProList.vue')
      }
    ]
  },
  {
    path: '/search',
    name: 'Search',
    meta: {
      title: '搜索'
    },
    component: () => import('@/website/Search.vue')
  },
  {
    path: '/productInfo',
    name: 'ProDetail',
    meta: {
      title: '产品详情'
    },
    component: () => import('@/website/product/ProDetail.vue')
  }
]


export default [
  ...commonRoutes,
  ...siteRoutes
]
